import { payloadConstants } from "../../constants/defaultValues";
import { RoomPropertyEnum } from "../../constants/NavbarList";
import {
  ROOM_TYPE_IS_HOURLY,
  ROOM_TYPE_IS_NIGHTLY,
} from "../../constants/RoomMaintainence";
import { mapRoomDefinitionExportRows } from "../mapping/roomDefinitionRows";
import { ExcelExportSheetConfig } from "../types";
import {
  VersaExcelHeader,
  VersaExcelSheetName,
  VersaExcelSourceField,
} from "../enums/versaExcel";
import { versaExcelColumn, versaExcelSheet } from "../enums/typedExcel";
import { ExcelBoolean, ExcelBooleanString, ExcelEmptyDefault } from "../constants/defaults";

/** Shared Post Type columns — Tax Post Type and Post Type use the same import sheet. */
const postTypeColumns = () => [
  versaExcelColumn(
    VersaExcelHeader.PostTypeNumber,
    VersaExcelSourceField.PostTypeNumber,
  ),
  versaExcelColumn(
    VersaExcelHeader.DepartmentName,
    VersaExcelSourceField.DepartmentName,
  ),
  versaExcelColumn(
    VersaExcelHeader.CategoryName,
    VersaExcelSourceField.CategoryName,
    ExcelEmptyDefault.Empty,
  ),
  versaExcelColumn(
    VersaExcelHeader.PostTypeName,
    VersaExcelSourceField.PostTypeName,
  ),
  versaExcelColumn(
    VersaExcelHeader.BuildingCode,
    VersaExcelSourceField.DefaultBuilding,
    ExcelEmptyDefault.Empty,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsActive,
    VersaExcelSourceField.IsActive,
    ExcelBoolean.True,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsCredit,
    VersaExcelSourceField.IsCredit,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsDeposit,
    VersaExcelSourceField.IsDeposit,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.AllowEarn,
    ExcelEmptyDefault.Empty,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.Characteristics,
    VersaExcelSourceField.Characteristics,
    payloadConstants[RoomPropertyEnum.postTypes].CHARACTERISTICS,
  ),
  versaExcelColumn(
    VersaExcelHeader.PostTypeCategory,
    VersaExcelSourceField.PostTypeCategory,
    payloadConstants[RoomPropertyEnum.postTypes].POST_TYPE_CATEGORY,
  ),
  versaExcelColumn(
    VersaExcelHeader.DefaultAmount,
    VersaExcelSourceField.DefaultAmount,
    payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_AMOUNT,
  ),
  versaExcelColumn(
    VersaExcelHeader.FloorLimit,
    VersaExcelSourceField.FloorLimit,
    payloadConstants[RoomPropertyEnum.postTypes].FLOOR_LIMIT,
  ),
  versaExcelColumn(
    VersaExcelHeader.CeilingLimit,
    VersaExcelSourceField.CeilingLimit,
    payloadConstants[RoomPropertyEnum.postTypes].CEILING_LIMIT,
  ),
  versaExcelColumn(
    VersaExcelHeader.GroupFunctionality,
    ExcelEmptyDefault.Empty,
    ExcelEmptyDefault.Empty,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsRequireReference,
    VersaExcelSourceField.IsRequiredReference,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsRestrictReservationPost,
    VersaExcelSourceField.IsRestrictReservationPost,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsRoomRevenue,
    VersaExcelSourceField.IsRoomRevenue,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsRequireComment,
    VersaExcelSourceField.IsRequireComment,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsPasscode,
    VersaExcelSourceField.IsPasscode,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsFood,
    VersaExcelSourceField.IsFood,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsBeverage,
    VersaExcelSourceField.IsBeverage,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsResource,
    VersaExcelSourceField.IsResource,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsRoomRental,
    VersaExcelSourceField.IsRoomRental,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsOther,
    VersaExcelSourceField.IsOther,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsFoodAndBevClassifier,
    VersaExcelSourceField.IsFoodAndBevClassifier,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.DefaultFolio,
    VersaExcelSourceField.DefaultFolio,
    payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_FOLIO,
  ),
  versaExcelColumn(
    VersaExcelHeader.DefaultMasterFolio,
    VersaExcelSourceField.DefaultMasterFolio,
    payloadConstants[RoomPropertyEnum.postTypes].DEFAULT_MASTER_FOLIO,
  ),
  versaExcelColumn(
    VersaExcelHeader.GlNumber,
    VersaExcelSourceField.GlNumber,
    payloadConstants[RoomPropertyEnum.postTypes].LEDGER_NUMBER,
  ),
  versaExcelColumn(
    VersaExcelHeader.GlOffsetNumber,
    VersaExcelSourceField.GlOffsetNumber,
  ),
  versaExcelColumn(
    VersaExcelHeader.SageExtractNumber,
    VersaExcelSourceField.SageExtractNumber,
    payloadConstants[RoomPropertyEnum.postTypes].SAGE_EXTRACT_NUMBER,
  ),
  versaExcelColumn(
    VersaExcelHeader.ExtractRevenueBucket,
    VersaExcelSourceField.ExtractRevenueBracket,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsCommissionable,
    VersaExcelSourceField.IsCommisionable,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.CommissionFlat,
    VersaExcelSourceField.CommissionFlat,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsChargedToCondoOwner,
    VersaExcelSourceField.IsChargedToCondoOwner,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsCommissionPercentage,
    VersaExcelSourceField.IsCommissionPecentage,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.CommissionPercentage,
    VersaExcelSourceField.CommissionPercentage,
    payloadConstants[RoomPropertyEnum.postTypes].COMMISSIONPERCENTAGE,
  ),
  versaExcelColumn(
    VersaExcelHeader.IsGiftCard,
    VersaExcelSourceField.IsGiftCard,
    ExcelBoolean.False,
  ),
  versaExcelColumn(
    VersaExcelHeader.GiftCardType,
    VersaExcelSourceField.GiftCardType,
    ExcelEmptyDefault.Empty,
  ),
  versaExcelColumn(
    VersaExcelHeader.PostTypeGrouping,
    ExcelEmptyDefault.Empty,
    ExcelEmptyDefault.Empty,
  ),
  versaExcelColumn(
    VersaExcelHeader.Taxes,
    VersaExcelSourceField.Taxes,
    ExcelEmptyDefault.Empty,
  ),
];

/**
 * Versa Excel export definitions — mapped to Versa onboarding payload keys only.
 * File/worksheet names follow the import template spec; sourceField maps onboarding data.
 */
export const versaExcelExportSheets: ExcelExportSheetConfig[] = [
  versaExcelSheet(
    RoomPropertyEnum.buildingCodes,
    VersaExcelSheetName.Building,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.TaxExemptCategories,
        VersaExcelSourceField.TaxExemptCategories,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
  ),

  versaExcelSheet(RoomPropertyEnum.Segment2, VersaExcelSheetName.Segment2, [
    versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.IsRouteLocalCalls,
      VersaExcelSourceField.IsRouteLocalCalls,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.ParentSegment1Code,
      VersaExcelSourceField.ParentSegment1Code,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.GuestTypeCode,
      VersaExcelSourceField.GuestTypeCode,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
  ]),

  versaExcelSheet(
    RoomPropertyEnum.PaymentMethods,
    VersaExcelSheetName.PaymentMethod,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.PaymentType,
        VersaExcelSourceField.PaymentType,
      ),
      versaExcelColumn(
        VersaExcelHeader.PostTypeNumber,
        VersaExcelSourceField.PostTypeNumber,
        payloadConstants[RoomPropertyEnum.PaymentMethods].POST_TYPE_NUMBER,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsUseSpecialGuarantee,
        VersaExcelSourceField.IsUseSpecialGuarentee,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.CreditLimit,
        VersaExcelSourceField.CreditLimit,
        payloadConstants[RoomPropertyEnum.PaymentMethods].CREDIT_LIMIT,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActivateInterface,
        VersaExcelSourceField.IsActivateInterface,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsRestrictPOSChanges,
        VersaExcelSourceField.IsRestrictPOSChanges,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsMovieRestrictions,
        VersaExcelSourceField.IsMovieRestrictions,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsInterfacePostToCheckoutFolio,
        VersaExcelSourceField.IsInterfacePostToCheckoutFolio,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.CentralResvEquivalent,
        VersaExcelSourceField.CentralResvEquivalent,
        payloadConstants[RoomPropertyEnum.PaymentMethods].CENTRAL_RESERVATION,
      ),
      versaExcelColumn(
        VersaExcelHeader.PhoneRestrictions,
        VersaExcelSourceField.PhoneRestrictions,
        payloadConstants[RoomPropertyEnum.PaymentMethods].PHONE_RESTRICTIONS,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
  ),

  versaExcelSheet(
    RoomPropertyEnum.roomFeatures,
    VersaExcelSheetName.RoomFeature,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsCondoOnly,
        VersaExcelSourceField.IsCondoOnly,
        ExcelBoolean.False,
      ),
    ],
  ),

  versaExcelSheet(
    RoomPropertyEnum.roomLocation,
    VersaExcelSheetName.RoomLocation,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsCondoOnly,
        VersaExcelSourceField.IsCondoOnly,
        ExcelBoolean.False,
      ),
    ],
  ),

  versaExcelSheet(
    RoomPropertyEnum.HousekeepingSections,
    VersaExcelSheetName.HouseKeepingSections,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.BuildingCode,
        VersaExcelSourceField.BuildingCode,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
  ),

  versaExcelSheet(
    RoomPropertyEnum.roomTypeMaintainence,
    VersaExcelSheetName.RoomTypeMaintenance,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.BuildingCode,
        VersaExcelSourceField.BuildingCode,
      ),
      versaExcelColumn(
        VersaExcelHeader.NoOfRooms,
        VersaExcelSourceField.NoOfRooms,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].NO_OF_ROOMS,
      ),
      versaExcelColumn(
        VersaExcelHeader.MaximumGuests,
        VersaExcelSourceField.MaximumGuests,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].MAX_GUESTS,
      ),
      versaExcelColumn(
        VersaExcelHeader.MaximumNights,
        VersaExcelSourceField.MaximumNights,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].MAX_NIGHTS,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsBedded,
        VersaExcelSourceField.IsBedded,
        ExcelBoolean.True,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsPerm,
        VersaExcelSourceField.IsPerm,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsUnblockPasscode,
        VersaExcelSourceField.IsUnblockPasscode,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsBlockRequired,
        VersaExcelSourceField.IsBlockRequired,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsAllowOversell,
        VersaExcelSourceField.IsAllowOversell,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsBlockingReminder,
        VersaExcelSourceField.IsBlockingReminder,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsSuite,
        VersaExcelSourceField.IsSuite,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Amount,
        VersaExcelSourceField.Amount,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].RESORT_FEE,
      ),
      versaExcelColumn(
        VersaExcelHeader.ResortFeeType,
        VersaExcelSourceField.ResortFeeType,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].RESORT_FEE_TYPE,
      ),
      versaExcelColumn(
        VersaExcelHeader.FeeFrequency,
        VersaExcelSourceField.FeeFrequency,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].FEE_FREQUENCY,
      ),
      versaExcelColumn(
        VersaExcelHeader.Adult,
        VersaExcelSourceField.Adult,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Youth,
        VersaExcelSourceField.Youth,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Teen,
        VersaExcelSourceField.Teen,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Child,
        VersaExcelSourceField.Child,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Todlers,
        VersaExcelSourceField.Todlers,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsROH,
        VersaExcelSourceField.IsROH,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.VillaHomeTemplateCode,
        VersaExcelSourceField.VillaHomeTemplateCode,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence]
          .VILLA_HOME_TEMPLATE_CODE,
      ),
      versaExcelColumn(
        VersaExcelHeader.PostTypeName,
        VersaExcelSourceField.PostTypeName,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].POST_TYPE_NAME,
      ),
      versaExcelColumn(
        VersaExcelHeader.CountRoomAs,
        VersaExcelSourceField.CountRoomAs,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].COUNT_ROOM_AS,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsPetAllowed,
        VersaExcelSourceField.IsPetAllowed,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.NoOfPets,
        VersaExcelSourceField.NoOfPets,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsNightly,
        ExcelEmptyDefault.True,
        ROOM_TYPE_IS_NIGHTLY,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsHourly,
        ExcelEmptyDefault.False,
        ROOM_TYPE_IS_HOURLY,
      ),
      versaExcelColumn(
        VersaExcelHeader.GapTime,
        VersaExcelSourceField.GapTime,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.MaximumOccupancy,
        VersaExcelSourceField.MaximumOccupancy,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.MinimumOccupancy,
        VersaExcelSourceField.MinimumOccupancy,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.Type,
        VersaExcelSourceField.Type,
        payloadConstants[RoomPropertyEnum.roomTypeMaintainence].TYPE,
      ),
      versaExcelColumn(
        VersaExcelHeader.SortOrder,
        ExcelEmptyDefault.Empty,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
  ),

  versaExcelSheet(
    RoomPropertyEnum.roomDefinitions,
    VersaExcelSheetName.RoomDefinition,
    [
      versaExcelColumn(
        VersaExcelHeader.IsSmoking,
        VersaExcelSourceField.IsSmoking,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsCotNotAllowed,
        VersaExcelSourceField.IsCotNotAllowed,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsCribNotAllowed,
        VersaExcelSourceField.IsCribNotAllowed,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.OwnershipType,
        VersaExcelSourceField.OwnershipType,
        "None",
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomNumber,
        VersaExcelSourceField.RoomNumber,
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomTypeCode,
        VersaExcelSourceField.RoomTypeCode,
      ),
      versaExcelColumn(
        VersaExcelHeader.BuildingCode,
        VersaExcelSourceField.BuildingCode,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsBedded,
        VersaExcelSourceField.IsBedded,
        ExcelBoolean.True,
      ),
      versaExcelColumn(
        VersaExcelHeader.Description,
        VersaExcelSourceField.Description,
        payloadConstants[RoomPropertyEnum.roomDefinitions].ROOM_DESCRIPTION,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsNoAutoPostRoomAndTax,
        VersaExcelSourceField.IsNoAutoPostRoomAndTax,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsSuite,
        VersaExcelSourceField.IsSuite,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsSystemRoom,
        VersaExcelSourceField.IsSystemRoom,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsPerm,
        VersaExcelSourceField.IsPerm,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.Beds,
        VersaExcelSourceField.Beds,
        payloadConstants[RoomPropertyEnum.roomDefinitions].BED_COUNT,
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomsForOccupancyTax,
        VersaExcelSourceField.RoomsForOccupancyTax,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.ConnectingRoomCodes,
        VersaExcelSourceField.ConnectingRoomCodes,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.SuiteRoomCodes,
        VersaExcelSourceField.SuiteRoomCodes,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.BlockingOrder,
        VersaExcelSourceField.BlockingOrder,
        0,
      ),
      versaExcelColumn(VersaExcelHeader.Floor, VersaExcelSourceField.Floor, 0),
      versaExcelColumn(
        VersaExcelHeader.EnergySection,
        VersaExcelSourceField.EnergySection,
        0,
      ),
      versaExcelColumn(
        VersaExcelHeader.KeyNumber,
        VersaExcelSourceField.KeyNumber,
        0,
      ),
      versaExcelColumn(
        VersaExcelHeader.LicenseFromDate,
        VersaExcelSourceField.LicenseFromDate,
      ),
      versaExcelColumn(
        VersaExcelHeader.LicenseToDate,
        VersaExcelSourceField.LicenseToDate,
      ),
      versaExcelColumn(
        VersaExcelHeader.PhysicalAddress,
        VersaExcelSourceField.PhysicalAddress,
        ExcelEmptyDefault.Empty,
      ),
      versaExcelColumn(
        VersaExcelHeader.StayOverPoints,
        VersaExcelSourceField.StayOverPoints,
        payloadConstants[RoomPropertyEnum.roomDefinitions].STAYOVER_POINTS,
      ),
      versaExcelColumn(
        VersaExcelHeader.CheckPoints,
        VersaExcelSourceField.CheckPoints,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CHECKOUT_POINTS,
      ),
      versaExcelColumn(
        VersaExcelHeader.LastDecorated,
        VersaExcelSourceField.LastDecorated,
      ),
      versaExcelColumn(
        VersaExcelHeader.MattressTurned,
        VersaExcelSourceField.MatressTurned,
      ),
      versaExcelColumn(
        VersaExcelHeader.HousekeepingSection,
        VersaExcelSourceField.HousekeepingSection,
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomFeatures,
        VersaExcelSourceField.RoomFeatures,
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomLocations,
        VersaExcelSourceField.RoomLocations,
      ),
      versaExcelColumn(
        VersaExcelHeader.RoomStatus,
        VersaExcelSourceField.RoomStatus,
        "V",
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoDescription,
        VersaExcelSourceField.CondoDescription,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_DESCRIPTION,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoFirstName,
        VersaExcelSourceField.CondoFirstName,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_FIRST_NAME,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoLastName,
        VersaExcelSourceField.CondoLastName,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_LAST_NAME,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoNightAvailable,
        VersaExcelSourceField.CondoNightAvailable,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoRentedToGuest,
        VersaExcelSourceField.CondoRentedToGuest,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoRentedToOwner,
        VersaExcelSourceField.CondoRendedToOwner,
        ExcelBoolean.False,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoRoomRevenue,
        VersaExcelSourceField.CondoRoomRevenue,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_ROOM_REVENUE,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoUnitCondition,
        VersaExcelSourceField.CondoUnitCondition,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_UNIT_CONDITION,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoAddress,
        VersaExcelSourceField.CondoAddress,
        payloadConstants[RoomPropertyEnum.roomDefinitions].CONDO_ADDRESS,
      ),
      versaExcelColumn(
        VersaExcelHeader.CondoContactDetails,
        VersaExcelSourceField.CondoContactDetails,
        payloadConstants[RoomPropertyEnum.roomDefinitions]
          .CONDO_CONTACT_DETAILS,
      ),
      versaExcelColumn(
        VersaExcelHeader.ListOrder,
        VersaExcelSourceField.ListOrder,
        1,
      ),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
    VersaExcelSheetName.RoomDefinition,
    mapRoomDefinitionExportRows,
  ),

  versaExcelSheet(RoomPropertyEnum.department, VersaExcelSheetName.Department, [
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
  ]),

  versaExcelSheet(RoomPropertyEnum.category, VersaExcelSheetName.Category, [
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.DepartmentName,
      VersaExcelSourceField.DepartmentName,
    ),
  ]),

  versaExcelSheet(
    RoomPropertyEnum.taxExemptCategory,
    VersaExcelSheetName.TaxExemptCategories,
    [
      versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
      versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
      versaExcelColumn(
        VersaExcelHeader.IsActive,
        VersaExcelSourceField.IsActive,
        ExcelBoolean.True,
      ),
    ],
  ),

  versaExcelSheet(RoomPropertyEnum.taxes, VersaExcelSheetName.Tax, [
    versaExcelColumn(VersaExcelHeader.TaxType, VersaExcelSourceField.TaxType),
    versaExcelColumn(
      VersaExcelHeader.PostTypeName,
      VersaExcelSourceField.PostTypeName,
    ),
    versaExcelColumn(
      VersaExcelHeader.ExemptDays,
      VersaExcelSourceField.ExemptDays,
    ),
    versaExcelColumn(
      VersaExcelHeader.EffectiveDate,
      VersaExcelSourceField.EffectiveDate,
    ),
    versaExcelColumn(
      VersaExcelHeader.TaxRangeTo,
      VersaExcelSourceField.TaxRangeTo,
    ),
    versaExcelColumn(
      VersaExcelHeader.PSTTax,
      VersaExcelSourceField.PSTTax,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.ExtractCode,
      VersaExcelSourceField.ExtractCode,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsTaxable,
      VersaExcelSourceField.IsTaxable,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsPostWithRoom,
      VersaExcelSourceField.IsPostWithRoom,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsSpecializedUse,
      VersaExcelSourceField.IsSpecializedUse,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsGSTTax,
      VersaExcelSourceField.IsGSTTax,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsOccupancyTax,
      VersaExcelSourceField.IsOccupancyTax,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsOCCTaxNoOfRooms,
      VersaExcelSourceField.IsOCCTaxNoOfRooms,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsPostTaxToFirstFolio,
      VersaExcelSourceField.IsPostTaxToFirstFolio,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsShowOnSplits,
      VersaExcelSourceField.IsShowOnSplits,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsExcludeFlatTaxOnZeroCharge,
      VersaExcelSourceField.IsExcludeFlatTaxOnZeroCharge,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.TaxExemptCategory,
      VersaExcelSourceField.TaxExemptCategory,
    ),
    versaExcelColumn(
      VersaExcelHeader.TaxMaintenances,
      VersaExcelSourceField.TaxMaintenances,
      "[]",
    ),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
  ]),

  versaExcelSheet(
    RoomPropertyEnum.taxPostTypes,
    VersaExcelSheetName.PostType,
    postTypeColumns(),
  ),

  versaExcelSheet(
    RoomPropertyEnum.postTypes,
    VersaExcelSheetName.PostType,
    postTypeColumns(),
  ),

  versaExcelSheet(RoomPropertyEnum.guestType, VersaExcelSheetName.GuestType, [
    versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.IsRouteLocalCalls,
      VersaExcelSourceField.IsRouteLocalCalls,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsTurndown,
      VersaExcelSourceField.IsTurndown,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsSkipResortFee,
      VersaExcelSourceField.IsSkipResortFee,
      ExcelBoolean.False,
    ),
    versaExcelColumn(
      VersaExcelHeader.CreditCardPreAuth,
      VersaExcelSourceField.CreditCardPreAuth,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.TaxExemptCategories,
      VersaExcelSourceField.TaxExemptCategories,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
  ]),

  versaExcelSheet(RoomPropertyEnum.origin, VersaExcelSheetName.Origins, [
    versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsRouteLocalCalls,
      VersaExcelSourceField.IsRouteLocalCalls,
      ExcelEmptyDefault.Empty,
    ),
  ]),

  versaExcelSheet(RoomPropertyEnum.Segment1, VersaExcelSheetName.Segment1, [
    versaExcelColumn(VersaExcelHeader.Code, VersaExcelSourceField.Code),
    versaExcelColumn(VersaExcelHeader.Name, VersaExcelSourceField.Name),
    versaExcelColumn(
      VersaExcelHeader.IsRouteLocalCalls,
      VersaExcelSourceField.IsRouteLocalCalls,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.GuestTypeCode,
      VersaExcelSourceField.GuestTypeCode,
      ExcelEmptyDefault.Empty,
    ),
    versaExcelColumn(
      VersaExcelHeader.IsActive,
      VersaExcelSourceField.IsActive,
      ExcelBoolean.True,
    ),
  ]),
];
